import React from 'react'
import i18n from 'live/services/i18n'
import styled from 'styled-components'
import { LiveMultiValuesWidgetConfig } from '../api'

interface Props {
    config: LiveMultiValuesWidgetConfig
    onChange: (key: string, value: unknown) => void
    variant?: 'light' | 'dark'
    className?: string
}

export default function BoxSizeSelector(props: Props): JSX.Element {
    const { boxSize } = props.config
    const darkVariant = props.variant === 'dark'
    const selectedClass = darkVariant ? 'selected' : 'selected-light'
    const cls = (props.className ?? '') + ' tooltip-options'

    const updateBoxSize = (_evt: React.MouseEvent, { value }: { value: unknown }): void =>
        props.onChange('boxSize', value)

    return (
        <div className={cls}>
            <label className="group-label">{i18n('Box size')}:</label>
            <BoxSizeSelectorContainer className="tooltip-toggler tooltip-toggler--narrow">
                <li
                    className={`${boxSize === 'small' ? selectedClass : ''}`}
                    onClick={evt => updateBoxSize(evt, { value: 'small' })}
                >
                    <div className="flex flex-center-items">
                        <Icon className="far fa-rectangle-wide fa-xs" />
                        <Description>{i18n('Small')}</Description>
                    </div>
                </li>
                <li
                    className={`${boxSize === 'medium' ? selectedClass : ''}`}
                    onClick={evt => updateBoxSize(evt, { value: 'medium' })}
                >
                    <div className="flex flex-center-items">
                        <Icon className="far fa-rectangle-wide box-medium" />
                        <Description>{i18n('Medium')}</Description>
                    </div>
                </li>
                <li
                    className={`${boxSize === 'large' ? selectedClass : ''}`}
                    onClick={evt => updateBoxSize(evt, { value: 'large' })}
                >
                    <div className="flex flex-center-items">
                        <Icon className="far fa-rectangle-wide box-large" />
                        <Description>{i18n('Large')}</Description>
                    </div>
                </li>
            </BoxSizeSelectorContainer>
        </div>
    )
}

const BoxSizeSelectorContainer = styled.ul`
    position: relative;
`

const Icon = styled.i`
    margin-left: 2px;
    font-size: 12px !important;

    &.box-medium {
        font-size: 15px !important;
    }

    &.box-large {
        font-size: 18px !important;
    }
`

const Description = styled.div`
    margin-left: 6px;
`
